import { CLEAR_PROGRAM, SET_PROGRAM } from "./actionTypes";
import { ProgramSession } from "../type";

export function setProgram(program: ProgramSession) {
    return {
        type: SET_PROGRAM,
        payload: program
    };
}

export function clearProgram() {
    return {
        type: CLEAR_PROGRAM
    };
}
